module.exports = __webpack_public_path__ + "static/img/7.5b60363.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/7.png
// module id = Numv
// module chunks = 0